<template>
  <v-container>
    <!-- {{ permitObj }} -->
    <div class="d-flex justify-space-between">
      <div class="tabs-max-width">
        <v-tabs v-model="tab" grow mobile-breakpoint="768px" class="tab-btn-style">
          <v-tab class="c-tab" v-if="permitObj.joinedStudents"> Joined Students </v-tab>
          <v-tab class="c-tab" v-if="permitObj.joinedTutors"> Joined Tutors</v-tab>
          <v-tab class="c-tab" v-if="permitObj.receiveCallData"> Received call data</v-tab>
          <v-tab class="c-tab" v-if="permitObj.tutorCV"> Tutors CV's</v-tab>
        </v-tabs>
      </div>
      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <joined-table :perm="permitObj"></joined-table>
        </v-tab-item>
        <v-tab-item> 
          <joined-tutors :perm="permitObj"></joined-tutors> 
        </v-tab-item>
        <v-tab-item>
          <received-call-table :perm="permitObj"></received-call-table>
        </v-tab-item>
        <v-tab-item>
          <tutor-cv :perm="permitObj"></tutor-cv>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import JoinedTable from "../../../components/RecordManagement/JoinedTable.vue";
import JoinedTutors from "../../../components/RecordManagement/JoinedTutors.vue";
import ReceivedCallTable from "../../../components/RecordManagement/ReceivedCallTable.vue";
import TutorCv from "../../../components/RecordManagement/TutorCv.vue";
import { getPermitObjects } from "../../../utils/allowedPermissions";

export default {
  name: "Records",
  components: {
    JoinedTable,
    JoinedTutors,
    TutorCv,
    ReceivedCallTable,
    BreadCrumbs,
  },
  data() {
    return {
      permitObj: {},
      tab: null,
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: "Records",
          disabled: true,
          to: {
            name: "Records",
          },
        },
      ],
    };
  },
  methods: {
    getPermittedArray() {
      console.log(this.$store, 'this.$store from RecordManagement');
      let links = this.$store?.getters?.permissions;
      let pathName = "RecordManagement";
      this.permitObj = getPermitObjects(links, pathName)
    }
  },
  mounted() {
    this.getPermittedArray();
    // console.log(this.$vuetify.theme.secondry)
  },
};
</script>

<style  lang="scss">
.nmt-1 {
  margin-top: -12px;
}
.c-tab {
  background: #f2f0f0;
  transition: background-color 0.2s;
  &.v-tab--active {
    background: white;
  }
}
</style>
<style scoped>
.tabs-max-width {
  width: 800px;
}
@media only screen and (max-width: 768px) {
  .tabs-max-width {
    width: 100% !important;
    min-width: 100% !important;
  }
  .d-flex.justify-space-between {
    display: block !important;
  }
}
</style>